(() => {
  if (typeof window === 'undefined') return;

  const initFadeInContainers = () => {
    const sections = document.querySelectorAll('.fade-in-container');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    });

    sections.forEach((section) => {
      if (section) observer.observe(section);
      return () => observer.unobserve(section);
    });
  };

  document.addEventListener('DOMContentLoaded', initFadeInContainers);
})();
